import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const SYNC_TRANSACTION_ENDPOINT = '/v1.0/sync-transactions'
const TXN_AMOUNT_HISTORY_ENDPOINT = '/v1.0/new/GetTxnAmountHistory'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = `${getEnvConfig('WEB_BASE_URL')}/ledger`

const api = new ApiService(endpoint, headers)
const apiV2 = new ApiService(endpoint.replace('v1', 'v2'), headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const editTransaction = (payload: object) => {
  return api.postRequest(SYNC_TRANSACTION_ENDPOINT, payload)
}

// Amount-edit trail for one transaction — the same endpoint Android's
// LedgerRemoteSource.getTransactionAmountHistory uses. Amounts come back as paise strings
// and timestamps as epoch-second strings; see ITransactionAmountHistory.
export const getTransactionAmountHistory = (transactionId: string) => {
  return api.postRequest(TXN_AMOUNT_HISTORY_ENDPOINT, { transaction_id: transactionId })
}

export const LedgerApi = {
  editTransaction,
  getTransactionAmountHistory
}
